import { contactInfo } from "../config/siteData";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const Contact = () => {
  const { t } = useLanguage();
  
  return (
    <section
      id="kontakt"
      className="py-16 md:py-24 bg-white"
      data-testid="contact-section"
    >
      <div className="container mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-sm font-medium tracking-wide uppercase text-[#D4A373] mb-3 block">
            {t.contact.subtitle}
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold font-['Outfit'] tracking-tight text-[#0F172A]"
            data-testid="contact-title"
          >
            {t.contact.title}
          </h2>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {/* Phone */}
          <a
            href={`tel:${contactInfo.phone}`}
            className="feature-card bg-[#FAFAF9] rounded-2xl p-6 text-center group hover:bg-[#004E64] transition-colors duration-300"
            data-testid="contact-phone"
          >
            <div className="w-14 h-14 rounded-xl bg-[#004E64] group-hover:bg-white flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
              <Phone className="w-6 h-6 text-white group-hover:text-[#004E64] transition-colors duration-300" />
            </div>
            <h3 className="text-lg font-semibold font-['Outfit'] text-[#0F172A] group-hover:text-white mb-2 transition-colors duration-300">
              {t.contact.phone}
            </h3>
            <p className="text-[#64748b] group-hover:text-white/80 transition-colors duration-300">
              {contactInfo.phone}
            </p>
          </a>

          {/* Email */}
          <a
            href={`mailto:${contactInfo.email}`}
            className="feature-card bg-[#FAFAF9] rounded-2xl p-6 text-center group hover:bg-[#004E64] transition-colors duration-300"
            data-testid="contact-email"
          >
            <div className="w-14 h-14 rounded-xl bg-[#004E64] group-hover:bg-white flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
              <Mail className="w-6 h-6 text-white group-hover:text-[#004E64] transition-colors duration-300" />
            </div>
            <h3 className="text-lg font-semibold font-['Outfit'] text-[#0F172A] group-hover:text-white mb-2 transition-colors duration-300">
              {t.contact.email}
            </h3>
            <p className="text-[#64748b] group-hover:text-white/80 transition-colors duration-300">
              {contactInfo.email}
            </p>
          </a>

          {/* WhatsApp */}
          <a
            href={`https://wa.me/${contactInfo.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="feature-card bg-[#FAFAF9] rounded-2xl p-6 text-center group hover:bg-[#25D366] transition-colors duration-300"
            data-testid="contact-whatsapp"
          >
            <div className="w-14 h-14 rounded-xl bg-[#25D366] group-hover:bg-white flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
              <MessageCircle className="w-6 h-6 text-white group-hover:text-[#25D366] transition-colors duration-300" />
            </div>
            <h3 className="text-lg font-semibold font-['Outfit'] text-[#0F172A] group-hover:text-white mb-2 transition-colors duration-300">
              WhatsApp
            </h3>
            <p className="text-[#64748b] group-hover:text-white/80 transition-colors duration-300">
              {t.contact.whatsapp}
            </p>
          </a>
        </div>
      </div>
    </section>
  );
};
